/**
 * №53 · 53.0.1 — THE ONE "needs you" glance count.
 *
 * Extracted from `ShellNav`'s rail-badge derivation (RC1-3: "a glance line counts
 * the full actionable set, once") so the strip's tile (D-CR2 deliverable 2) can
 * never disagree with the rail row it echoes. Before this hook existed the count
 * was computed inline in ShellNav only; adding a SECOND surface that needed the
 * same number and re-deriving it there would have re-opened the exact defect
 * class RC1-3 was written to close (S3/S4 found the badge under-counting twice —
 * see ShellNav.tsx's history for the full account).
 *
 * decisions + approvals. Waits are excluded deliberately — a wait is work sitting
 * with someone else, and a glance line that counts other people's queues asks you
 * to look at something you cannot act on.
 */
import { useQuery } from "@tanstack/react-query";
import { NEEDS_YOU_KEY } from "./needs-you-key";
import { mcpClient } from "../../lib/mcp-client";
import { usePendingAuthorisations } from "./use-ledger-approvals";
import { useWorkspaceNeedsYou } from "./use-workflow";

export function useNeedsYouGlanceCount(): number {
  const pending = usePendingAuthorisations();
  const needsYouQ = useQuery({
    queryKey: NEEDS_YOU_KEY,
    queryFn: () => mcpClient.listNeedsYou(),
    staleTime: 5_000,
    select: (f) => f.tasks,
  });
  const wfNeedsYou = useWorkspaceNeedsYou();

  return (
    (pending.data?.authorisations.length ?? 0)
    + (needsYouQ.data ?? []).filter((t) => (t.needs_you_reason ?? "").trim().length > 0).length
    + (wfNeedsYou.data?.items ?? []).filter((it) => it.kind !== "wait").length
  );
}
